import itemCount from '../../api/item_count'

export default {
    namespaced: true,
    state: {
        count: 0,
        isLoaded: false,
    },
    mutations: {
        setData: (state, data) => {
            state.count = data.count
            state.isLoaded = true
        },
        setUnloaded: state => {
            state.isLoaded = false
        }
    },

    getters: {
        count: state => {
            return state.count
        },
        isLoaded: state => {
            return state.isLoaded
        }
    },

    actions: {
        getCount: async function({commit, getters}, conditions) {
            commit('setUnloaded')
            await itemCount.getCount(conditions, async res => {
                await commit('setData', res.data.data)
            })
        }
    }
}


